// angular
import { ChangeDetectionStrategy, Component } from '@angular/core';
// libs
import { DynamicFormSelectBaseComponent } from '@luggagehero/features/ui';

@Component({
  selector: 'lh-dynamic-form-select',
  templateUrl: './dynamic-form-select.component.html',
  styleUrls: ['./dynamic-form-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicFormSelectComponent extends DynamicFormSelectBaseComponent {}
